export default __webpack_public_path__ + "static/media/ribbon.e52e64fd.svg";